import * as actionTypes from './../Register_action.types';
import * as api from './../register_api_services/Emp_Separation.api';


export const getEmp_SeparationRequest = () => ({
  type: actionTypes.GET_EMP_SEPARATION_REQUEST,
});

export const getEmp_SeparationSuccess = (emp_separation) => ({
  type: actionTypes.GET_EMP_SEPARATION_SUCCESS,
  payload: emp_separation,
});

export const getEmp_SeparationFailure = (error) => ({
  type: actionTypes.GET_EMP_SEPARATION_FAILURE,
  payload: error,
});

export const getEmp_Separation = (date) => {
  return async (dispatch) => {
    dispatch(getEmp_SeparationRequest(date));
    try {
      const emp_separation = await api.fetchEmp_SeparationData(date);
      dispatch(getEmp_SeparationSuccess(emp_separation));
      return { success: true, data: emp_separation };
    } catch (error) {
      dispatch(getEmp_SeparationFailure(error));
      return { success: false, message: error };
    }
  };
};


export const updateEmp_SeparationRequest = (id, Emp_SeparationData) => ({
  type: actionTypes.UPDATE_EMP_SEPARATION_REQUEST,
  payload: { id, Emp_SeparationData },
});

export const updateEmp_SeparationSuccess = (message) => ({
  type: actionTypes.UPDATE_EMP_SEPARATION_SUCCESS,
  payload: message,
});

export const updateEmp_SeparationFailure = (error) => ({
  type: actionTypes.UPDATE_EMP_SEPARATION_FAILURE,
  payload: error,
});


export const updateEmp_SeparationById = (id, Emp_SeparationData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    Emp_SeparationData.updated_by = user.user_name;

    dispatch(updateEmp_SeparationRequest(id, Emp_SeparationData));
    try {
      const response = await api.updateEmp_Separation(id, Emp_SeparationData);
      dispatch(updateEmp_SeparationSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updateEmp_SeparationFailure(error));
      return { success: false, message: error };
    }
  };
};


export const deleteEmp_SeparationRequest = (id) => ({
  type: actionTypes.DELETE_EMP_SEPARATION_REQUEST,
  payload: id,
});

export const deleteEmp_SeparationSuccess = (message) => ({
  type: actionTypes.DELETE_EMP_SEPARATION_SUCCESS,
  payload: message,
});

export const deleteaternityBenefitsFailure = (error) => ({
  type: actionTypes.DELETE_EMP_SEPARATION_FAILURE,
  payload: error,
});



export const deleteEmp_SeparationById = (id) => {
  return async (dispatch) => {
    dispatch(deleteEmp_SeparationRequest(id));
    try {
      const response = await api.deleteEmp_Separation(id);
      dispatch(deleteEmp_SeparationSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteaternityBenefitsFailure(error));
      return { success: false, message: error };
    }
  };
};


export const uploadEmp_SeparationRequest = (fileData) => ({
  type: actionTypes.UPLOAD_EMP_SEPARATION_REQUEST,
  payload: fileData,
});

export const uploadEmp_SeparationSuccess = (message) => ({
  type: actionTypes.UPLOAD_EMP_SEPARATION_SUCCESS,
  payload: message,
});

export const uploadEmp_SeparationFailure = (error) => ({
  type: actionTypes.UPLOAD_EMP_SEPARATION_FAILURE,
  payload: error,
});


export const uploadEmp_SeparationFile = (fileData) => {
  return async (dispatch) => {
    dispatch(uploadEmp_SeparationRequest(fileData));
    try {
      const response = await api.upload_Emp_separation(fileData);
      dispatch(uploadEmp_SeparationSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(uploadEmp_SeparationFailure(error));
      const errorMessage = error?.response?.data?.error || error?.message || 'Upload failed';
      return { success: false, error: errorMessage };
    }
  };
};

export const multiDaleteEmp_SeparationRequest = (ids) => ({
  type: actionTypes.MULTIDELETE_EMP_SEPARATION_REQUEST,
  payload: ids,
});

export const multiDaleteEmp_SeparationSuccess = (message) => ({
  type: actionTypes.MULTIDELETE_EMP_SEPARATION_SUCCESS,
  payload: message,
});

export const multiDaleteEmp_SeparationFailure = (error) => ({
  type: actionTypes.MULTIDELETE_EMP_SEPARATION_FAILURE,
  payload: error,
});


export const multiDeleteEmp_Separations = (ids) => {
  return async (dispatch) => {
    dispatch(multiDaleteEmp_SeparationRequest(ids));
    try {
      const response = await api.multiDeleteEmp_Separation(ids);
      dispatch(multiDaleteEmp_SeparationSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(multiDaleteEmp_SeparationFailure(error));
      return { success: false, message: error };
    }
  };
};












